module.exports = __webpack_public_path__ + "img/payment-card-check.4391adc2.svg";